'use client';
export { GlobalError as default } from '~/module/error/global-error';
